// extracted by mini-css-extract-plugin
export default {"divider":"footer_divider__otlir","footerContainer":"footer_footerContainer__9Gvf-","logo":"footer_logo__htIlA","nav":"footer_nav__Ro1cz","copyright":"footer_copyright__dMSvT"};